import "react-calendar/dist/Calendar.css";
import React, { useState, useEffect, useRef } from "react";
import {default as ReactSelect ,  components } from "react-select";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { useTranslation } from "react-i18next";
import DateRangeSelector from "./calendars/DateRangeSelector";
import DateFormat from "../../pages/DateFormat";
import {getRangeDates} from "../../services/Util";
import dateUtil, {DATE_FORMATS} from "../../services/DateUtil";
import {setCalendarDateRange } from "../../redux/reducers/CalendarRangeSlice";
import Constants from "../../Constants";
import { CalendarIcon, InterChangeIcon } from "../../AppIcons";


export default function DateRangeFilter(prop) {

  const refCalendar = useRef(null);
  const refToggle = useRef(null);
  const refToggleCalendarButton = useRef(null);
  const [toggle, toggleCal] = useState(false);
  const dispatch = new useDispatch();
  const { t : translate} = useTranslation();
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const selectedRange = useSelector((CalendarRangeSlice) => CalendarRangeSlice.calendar_range).range;
  const dateRange = getRangeDates(selectedRange);

  const rangeOptions = Constants.DATE_RANGE_VALUES.map((range) => ({value :  range.code, label : translate("calendar."+range.code)}));
  const stylesMonthSelect = {
    border: aaaSelected ? "0.8px solid #7CB4DD" : "0.8px solid #7CB4DD",
    borderRadius: "30px",
    height: "50px",
    fontSize: "85.71429%",
    color: aaaSelected ? "white" : "#1C233C",
    background: aaaSelected ? "black" : "#EEF8FD",
    //borderRadius: "17px",
    padding: "6px 16px",
    display: "flex",
  };

  const enableRangeSelection = () => {return (prop.showRangeDropDown === false || selectedRange.code === "custom" )};
  const onDateRangeChange = (code, dates )=>{
    localStorage.setItem("globalSearch",false);
    const range = Object.assign({},Constants.DATE_RANGE_VALUES.find((range) => range.code === code));
    if(range.code === "custom"){
        range.dates = dates === null ? [dateRange[0],dateRange[1]] : dates;
    }
    dispatch(setCalendarDateRange(range));
  }

  const showRangeCalendar = (e) => {
    toggle ? toggleCal(false) : toggleCal(true);
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      requiredElement.focus();
    }
  }

  const closeCalendar = (e) => {
    if (e.code === "Escape") {
      toggleCal(false);
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      const icon = event?.target?.classList?.contains("calender-icon");
      if (
        refCalendar?.current &&
        !refCalendar?.current?.contains(event?.target) &&
        !refToggle?.current?.contains(event?.target) &&
        !refToggleCalendarButton?.current?.contains(event?.target) &&
        !icon
      ) {
        toggleCal(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("focus", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("focus", handleClickOutside, true);
    };
  }, [refCalendar]);

  useEffect(() => {
    if(!toggle){
        refToggleCalendarButton?.current.focus();
    }
  }, [toggle]);

  return (
    <>
        <div className="filter-inline-list">
          <div className="filter-date flex-center">
            <button
              className={(enableRangeSelection()? "calenderIcon" : "calenderIcon disabled")}
              onClick={(e) => {
                showRangeCalendar(e);
              }}
              onKeyDown={(e) => {
                closeCalendar(e);
              }}
              ref={refToggleCalendarButton}
              tabIndex={0}
              aria-label={
                "Start date " +
                dateUtil.format(dateRange[0], DATE_FORMATS.DATE, null) +
                " End Date " +
                dateUtil.format(dateRange[1], DATE_FORMATS.DATE, null)
              }
              aria-expanded={toggle}
            >
             <CalendarIcon/>
            </button>

            {toggle ? (
              <div
                ref={refCalendar}
                onKeyDown={(e) => {
                  closeCalendar(e);
                }}
              >
                <DateRangeSelector
                  calendarType="US"
                  locale="en"
                  selectRange={true}
                  className={"dashCalendar"}
                  returnValue="range"
                  onDateChange={(returnValue, event) => {
                    onDateRangeChange("custom", returnValue);
                  }}
                  showDoubleView={true}
                   value={[new Date(dateRange[0]), new Date(dateRange[1])]}
                />
              </div>
            ) : (
              ""
            )}
            <div className="flex-center">
              <span
              className={(enableRangeSelection() ? "" : "disabled")}
                onClick={(e) => {
                  if(enableRangeSelection()){
                    showRangeCalendar(e);
                  }
                }}
                ref={refToggle}
              >
                <DateFormat date={dateRange[0]} format = {prop.dateFormat} timezone={null}/>
              </span>
              <InterChangeIcon/>
              <span
              className={(enableRangeSelection() ? "" : "disabled")}
                onClick={(e) => {
                  if(enableRangeSelection()){
                    showRangeCalendar(e);
                  }
                }}
                ref={refToggle}
              >
                <DateFormat date={dateRange[1]} format = {prop.dateFormat} timezone={null}/>
              </span>
            </div>
          </div>
        </div>
        {prop.showRangeDropDown &&
        <div className="filter-inline-list flex-center">
          <div className="drop-down flex-center global-dropdown-block mb-0">
            <ReactSelect  classNamePrefix='cw'
                aria-label="Project status"
                className="global-dropdown-select"
                style={stylesMonthSelect}
                value={rangeOptions.filter((option) => (option.value === selectedRange.code))}
                options={rangeOptions}
                onChange={e => onDateRangeChange(e.value, null)}
                  />
          </div>
        </div>
}
    </>
  );
}
